/**
 * 普惠其他相关页面
 */
const otherRouter = [
  {
    path: '/save-money',
    component: () => import('@/views/personalcenter/index'),
    name: 'SaveMoney',
    meta: { title: '省钱记录', auth: false },
  },
  {
    path: '/suggest',
    component: () => import('@/views/detailspage/volume/suggest.vue'),
    name: 'Suggest',
    meta: { title: '普惠说明', auth: false },
  },
];

export default otherRouter;
